import { connect } from 'react-redux';

import { requestFilters } from "store/filters/actions";
import {
  isInitialized,
  getPrimaryFilterToggleText,
  getPrimaryFilterCTA,
  getSecondaryFilterToggleText,  
  getSecondaryFilterCTA,
} from 'store/filters/selectors';

import { 
  isResultsLoading, 
  getPageTitle, 
  getDefaultPageTitle,
} from '../../store/results/selectors';

import { 
  getLocation,
} from '../../store/search/selectors';

import { SearchScreen } from "./SearchScreen";

const mapStateToProps = (state) => ({
  isInitialized: isInitialized(state),  
  searchOptionsToggle: getPrimaryFilterToggleText(state),
  filtersToggle: getSecondaryFilterToggleText(state),
  primaryFilterCTA: getPrimaryFilterCTA(state),
  secondaryFilterCTA: getSecondaryFilterCTA(state),
  isLoading: isResultsLoading(state),
  settings: getLocation(state),
  defaultPageTitle: getDefaultPageTitle(state),
  pageTitle: getPageTitle(state),
});

const mapDispatchToProps = dispatch => ({
  fetchFilters: () => dispatch(requestFilters()),
});

export const SearchScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchScreen);
